import { ModelTypeEnum } from 'modules/environments/interfaces';
import { getFieldStateKeyByProvider } from '../cloudProviderUtils';
import { GenericFormItemWithLoadingKey } from '../utils';

const getLoadingKeyByProvider = (providerType = ModelTypeEnum.customImage) =>
  ({
    [ModelTypeEnum.customImage]: 'isLoadingImages',
    [ModelTypeEnum.bootVolume]: 'isLoadingBootVolumes',
    [ModelTypeEnum.bootVolumeBackup]: 'isLoadingBootVolumeBackups',
  }[providerType]);

const ociFields = (
  providerType = ModelTypeEnum.customImage
): GenericFormItemWithLoadingKey[] => [
  {
    gridXs: 12,
    label: `${providerType?.toUpperCase()}_KEY`,
    stateKey: getFieldStateKeyByProvider(providerType),
    isSelect: true,
    options: [],
    isLoadingKey: getLoadingKeyByProvider(providerType),
  },
  {
    gridXs: 6,
    label: 'Subnet',
    stateKey: 'provider_data.subnet',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingSubnets',
  },
  {
    gridXs: 6,
    label: 'FLAVOR_KEY',
    stateKey: 'provider_data.flavor',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingFlavors',
  },
  {
    gridXs: 6,
    label: 'ZONE_KEY',
    stateKey: 'provider_data.zone',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingZones',
  },
  {
    gridXs: 6,
    label: 'SECURITY_GROUP_KEY',
    stateKey: 'provider_data.security_group',
    isSelect: true,
    options: [],
    isLoadingKey: 'isLoadingSecurityGroups',
  },
];

export default ociFields;
